import { useNavigate, useLocation } from "react-router-dom";

export const useNavigateWithRedirect = () => {

  const navigate = useNavigate();
  const location = useLocation();

  return (path, options = {}) => {

    if (typeof path === "number") {
      navigate(path);
      return;
    }

    if (path === "/login") {
      navigate(path, {
        ...options,
        state: {
          from: {
            pathname: location.pathname,
            search: location.search
          }
        }
      });
      return;
    }

    navigate(path, options);
  };
};